/**-----------------------------------------------------------------------------
 *                                    E2RH
 * -----------------------------------------------------------------------------
 *
 *  filename: importCsv.tsx
 *
 *  author: tcleret
 *
 *  creation: 16/12/2025 - 11:46
 *
 *  description:
 *
 *  Copyright (c) 2025 E2RH
 * -----------------------------------------------------------------------------
 */

import * as React from "react";

/**
 * Interface to import data from CSV file
 * @returns
 */
export default function ImportCsv() {
   return (
      <div className="action_content">
         <h3>ImportCsv</h3>
      </div>
   );
}
